import {
    useGuideCommandListener,
    type GuideCommandPayload,
} from "@repo/events-guide";
import {
    coeditingEditStreamChannel,
    coeditingEventStreamChannel,
} from "@repo/guide-coeditor-core";

import {
    parseCoeditingEdit,
    parseCoeditingEvent,
    type CoeditingEvent,
} from "../events.ts";

/**
 * This is a wrapper around the common `useGuideCommandListener` that adds a
 * bit of coediting-specific behavior.
 *
 * Notably:
 * - There are two "channels" that the coediting framework uses to stream
 *   messages to the client: the "edit channel" and the "event channel".
 *   This listener handles figuring out which of these channels the message
 *   is for, parsing the message, and delegating to the appropriate callback
 *   (either `handleChunk` or `handleEvent`).
 */
export default function useCoeditingCommandListener(
    handleChunk: (placeholderKey: string, chunk: string) => void,
    handleEvent: (event: CoeditingEvent) => void,
) {
    useGuideCommandListener(({name, content}: GuideCommandPayload) => {
        switch (name) {
            case coeditingEditStreamChannel: {
                const parsed = parseCoeditingEdit(content);
                if (!parsed) {
                    return;
                }

                const [placeholderKey, chunk] = parsed;

                handleChunk(placeholderKey, chunk);
                return;
            }

            case coeditingEventStreamChannel: {
                const event = parseCoeditingEvent(content);
                if (!event) {
                    return;
                }

                handleEvent(event);
                return;
            }
        }
    });
}
